import React, { useState } from 'react';

export default function PermitList({ sectionName, permits, onShowPermit, hide }) {
    const dateFormatter = new Intl.DateTimeFormat('en-US', { day: "2-digit", month: "2-digit", year: "numeric" });

    let permitListItems = permits && permits
        .map(permitItem => <tr key={permitItem.id}>
            <td><span onClick={() => onShowPermit(permitItem.id)}>{permitItem.identifier}</span></td>
            <td>{permitItem.noiSubmittalDate && dateFormatter.format(new Date(permitItem.noiSubmittalDate))}</td>
            <td>{permitItem.noiAuthorizationDate && dateFormatter.format(new Date(permitItem.noiAuthorizationDate))}</td>
            <td>{permitItem.notSubmittalDate && dateFormatter.format(new Date(permitItem.notSubmittalDate))}</td>
            <td>{permitItem.notApprovalDate && dateFormatter.format(new Date(permitItem.notApprovalDate))}</td>
            <td className="smallScreen">
                <div className="log">
                    {permitItem.id && permitItem.identifier && (<div>
                        <span className="fieldDesc">NPDES Permit ID:</span>
                        <span onClick={() => onShowPermit(permitItem.id)}>{permitItem.identifier}</span>
                    </div>)}
                    {permitItem.noiSubmittalDate && (<div>
                        <span className="fieldDesc">NOI Submittal:</span>
                        {permitItem.noiSubmittalDate && dateFormatter.format(new Date(permitItem.noiSubmittalDate))}
                    </div>)}
                    {permitItem.noiAuthorizationDate && (<div>
                        <span className="fieldDesc">NOI Authorization:</span>
                        {permitItem.noiAuthorizationDate && dateFormatter.format(new Date(permitItem.noiAuthorizationDate))}
                    </div>)}
                    {permitItem.notSubmittalDate && (<div>
                        <span className="fieldDesc">NOT Submittal:</span>
                        {permitItem.notSubmittalDate && dateFormatter.format(new Date(permitItem.notSubmittalDate))}
                    </div>)}
                    {permitItem.notApprovalDate && (<div>
                        <span className="fieldDesc">NOT Approval:</span>
                        {permitItem.notApprovalDate && dateFormatter.format(new Date(permitItem.notApprovalDate))}
                    </div>)}
                </div>
            </td>
        </tr>);

    let logList = permitListItems.length === 0 ? undefined : (<table id="permitList" className="itemList">
        <thead>
            <tr>
                <th>NPDES Permit ID</th>
                <th className="date">NOI Submittal</th>
                <th className="date">NOI Authorization</th>
                <th className="date">NOT Submittal</th>
                <th className="date">NOT Approval</th>
            </tr>
        </thead>
        <tbody>{permitListItems}</tbody>
    </table>);

    //let selectLogType = onSelectLogType && (<span className="select" onClick={() => onSelectLogType()}><i className={logTypeSelected ? "dhicon-check-2" : "dhicon-check-empty"} /></span>);
    let selectLogType;

    //let iconClass = isClosed ? "dhicon-right-open-2" : "dhicon-down-open-4";
    //let openClose = (<i className={`icon ${iconClass}`} onClick={() => setIsClosed(!isClosed)} />);
    let openClose;
    
    let sectionNameDescription = false && sectionName && (<div className="logType">
        <div className="flexbox-flex align-start overflow-x-hidden">
            {selectLogType}
            <span className="nameContainer">
                <span className="name">{sectionName}</span>
            </span>
        </div>
        {openClose}
    </div>);

    let hideClass = hide && "hidden"

    return (
        <div className={`logTypeContainer permits ${hideClass}`}>
            {sectionNameDescription}
            {logList}
        </div>
    );
}